<template>
  <div :class="$style.wrapper">
    <button :disabled="isDisabled" :class="$style.sendBtn" @click.prevent="isShowRequestDialog = true">
      <i class="icon-envelope-o" :class="$style.envelope"></i>
      <span v-if="!isSubscribed" :class="$style.sendLink">再出品メールを受け取る</span>
      <span v-else>再出品メール登録済み</span>
    </button>
    <IMenu v-if="!isDisabled" v-model="isShowMenu" :title="isFirst ? '再出品メールを登録してみませんか？' : '再出品メールとは？'" width="300" @hide="onHideMenu">
      <template #link>
        <i class="icon-question-circle" :class="$style.question"></i>
      </template>
      <template #menu> 作品が再出品された時にメールでお知らせします。(※利用者の情報は出品者には通知されません) </template>
    </IMenu>
    <IModal v-model="isShowRequestDialog">
      <p :class="$style.lead">作品が再出品された時にメールでお知らせします。<br />(※利用者の情報は出品者には通知されません)</p>
      <Form @submit="onSubmit">
        <template v-if="userStore.isAuthenticated">
          <IButton type="primary" native-type="submit">登録</IButton>
          <p v-if="!isFollowed" :class="$style.check">
            <label><input v-model="followMember" type="checkbox" /> お気に入りショップに保存する</label>
          </p>
        </template>
        <template v-else>
          <div class="mb-10">
            <ITextField v-model.trim="email" name="メールアドレス" title="メールアドレス" type="email" rules="required|email|max:200" />
          </div>
          <IButton type="primary" native-type="submit">登録</IButton>
          <p :class="$style.check">
            <label><input v-model="mailMagazine" type="checkbox" /> iichiのメールマガジンに登録する</label>
          </p>
        </template>
      </Form>
    </IModal>
    <IModal v-model="isShowErrorDialog">
      <p v-if="errorMsg">{{ errorMsg }}</p>
      <p v-else>
        処理中にエラーが発生しました。<br />
        しばらくしてからもう一度ボタンを押して下さい。<br />
        <br />
        何度もエラーが起きる場合はiichi運営事務局までお問い合わせ下さい。
      </p>
    </IModal>
  </div>
</template>

<script setup lang="ts">
import { Form } from 'vee-validate';
import { ref, computed, onMounted } from 'vue';
import { getFromStorage, setToStorage } from '@/js/lib/helper/expirable-local-storage';
import { requestStart } from '@/js/lib/api/item';
import { useMemberStore } from '@/js/lib/store/member';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import IButton from '@/js/components/molecules/IButton.vue';
import IMenu from '@/js/components/molecules/IMenu.vue';
import IModal from '@/js/components/molecules/IModal.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';

const props = defineProps<{
  itemId: number;
  shopId: number;
  isMe: number;
  isSubscribed: number;
}>();
const storageKey = 'close_requestballoon';
const userStore = useUserStore();
const memberStore = useMemberStore();
const email = ref('');
const followMember = ref(false);
const mailMagazine = ref(false);
const isShowMenu = ref(false);
const isShowRequestDialog = ref(false);
const isShowErrorDialog = ref(false);
const errorMsg = ref('');
const isFollowed = computed(() => memberStore.followedMemberIds.includes(props.shopId));
const isFirst = computed(() => !getFromStorage({ key: storageKey }));
const isDisabled = computed(() => Boolean(props.isMe) || Boolean(props.isSubscribed));
const onHideMenu = () => {
  setToStorage({ key: storageKey, value: true, expirationSeconds: 86400 * 365 });
};
const onSubmit = () => {
  loading({
    asyncFunc: async () => {
      try {
        await requestStart({
          itemId: props.itemId,
          email: email.value,
          followMember: followMember.value,
          mailMagazine: mailMagazine.value,
        });
        window.location.reload();
      } catch (error) {
        if (error.response.data.message) {
          errorMsg.value = error.response.data.message;
        }
        isShowRequestDialog.value = false;
        isShowErrorDialog.value = true;
      }
    },
  });
};

onMounted(() => {
  isShowMenu.value = !props.isSubscribed && isFirst.value;
});
</script>

<style module lang="scss">
.wrapper {
  margin: -10px 0 20px;
}

.sendBtn {
  margin-right: 4px;

  .envelope {
    color: #54a8f5;
    font-size: 22px;
    margin-right: 6px;
    position: relative;
    top: 5px;
  }

  span {
    display: inline-block;

    &.sendLink {
      border-bottom: 1px dashed $gray600;
    }
  }

  &:disabled {
    .envelope,
    span {
      color: #bfbfbf;
    }

    span.sendLink {
      border-bottom: none;
    }
  }
}

.question {
  color: #d9d9d9;
  font-size: 16px;
  position: relative;
  top: 3px;
}

.lead {
  margin-bottom: 1em;
}

.check {
  margin: 16px 0 0;

  input[type='checkbox'] {
    height: 20px;
    vertical-align: middle;
    width: 20px;
  }
}
</style>
